import React from 'react';
import Button from './index.js';

const PrimaryButton = props => (
    <Button buttonType="button-primary" {...props} />
);
export default PrimaryButton;
